import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';

import { ProgrammingEventService } from '../../common/services/event.service';

@Component({
  selector: 'prg-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.less'],
  providers: []
})
export class ProgrammingEventComponent implements OnInit {
  event: Observable<any>;
  toolbarActions: Array<any>;

  constructor(
    private router: Router,
    private store: Store<any>,
    private route: ActivatedRoute,
    private eventService: ProgrammingEventService
  ) {
    this.event = this.store.select(s => s.advancedProgramming.event.event);

    this.event.subscribe(event => console.log('event.cmp: event update', event));

    this.toolbarActions = [{
      name: 'close',
      iconClass: 'fa fa-fw fa-times',
      label: 'Close'
    }];
  }

  ngOnInit() {
    this.route.params.take(1).subscribe(
      (params: any) => {
        console.log('nav: event params: ', params);
        if (params && params['deviceId'] && params['eventId']) {
          this.eventService.retrieve(params['deviceId'], params['eventId']);
        }
      });
  }

  toolbarActionInvoked(event, action) {
    this.eventService.clear();
    // NOTE for now there is only one action, which is close, so just navigate away
    this.router.navigate(['../'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/advanced/event/event.component.ts